import React from 'react'
import { observer } from 'mobx-react'
import classnames from 'classnames'
import MarkersWithinListItem from './MarkersWithinListItem'
import { withTranslation } from 'react-i18next'

// This container is always rendered, but renders e.g. a chart,
// an error, or nothing depending on the state of the selection
const MarkersWithinList = ({ markers, selectedMarkerId, t }) => (
  <section className='markers-list-container'>
    {
      markers.length === 0
        ? <p className='markers-count'>{t('GLOBAL.MARKERS_WITHIN_NOT_FOUND')}</p>
        : <p className='markers-count'>{t('GLOBAL.MARKERS_WITHIN_COUNT', { count: markers.length })}</p>
    }
    <ul className={classnames({
      'markers-within-list': true,
      unstyled: true,
      'nested-list': true,
      'flex-grow': true
    })}
    >
      {
        markers.map(marker => (
          <MarkersWithinListItem
            key={marker.id}
            marker={marker}
            selected={selectedMarkerId === marker.id}
          />
        ))
      }
    </ul>
  </section>
)

export default withTranslation()(observer(MarkersWithinList))
